/** @jsxRuntime classic */
/* @jsx node */
// @ts-ignore
import { PaymentMethodsZoidSkeleton } from 'app/sdk/components/PaymentMethods';
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ConektaIframeConfig, ConektaSource } from 'app/sdk/embedded/EmbeddedConfig';
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { node, dom } from 'jsx-pragmatic';

const zoid = require('zoid/dist/zoid');

let zoidComponent: any = null;
const dimensions = {
  height: '100%',
  width: '100%',
};

export const createChildZoidInternalCheckout = () =>
  zoid.create({
    tag: 'conekta-internal-checkout-component',
    url: `${process.env.BASE_URL}components/self-hosted-checkout-frame`,
    dimensions,
  });

export const createParentZoidInternalCheckout = (locale?: string) =>
  zoid.create({
    tag: 'conekta-internal-checkout-component',
    url: `${process.env.BASE_URL}components/self-hosted-checkout-frame${locale ? `?locale=${locale}` : ''}`,
    dimensions,
    prerenderTemplate: ({ doc }: any) => ((<PaymentMethodsZoidSkeleton />) as any).render(dom({ doc })),
  });

export const InternalCheckoutInitAndRenderHandler = (iframeConfig: ConektaIframeConfig) => {
  const { locale, targetIFrame, isIntegration, config } = iframeConfig as any;
  if (isIntegration) {
    iframeConfig.conektaSource = ConektaSource.REDIRECTED;
  } else {
    iframeConfig.conektaSource = ConektaSource.PAYMENT_LINK;
  }
  zoidComponent = zoidComponent || createParentZoidInternalCheckout(config?.locale || locale);
  zoidComponent(iframeConfig).render(config?.targetIFrame || targetIFrame);
};
